import { useEffect, useRef, useState } from "react";

const WARN_AFTER = 25 * 60 * 1000;  // 25 min idle → show warning
const LOGOUT_AFTER = 30 * 60 * 1000; // 30 min idle → sign out

export default function useSessionTimeout(onSignOut) {
  const [countdown, setCountdown] = useState(null);
  const warnTimer   = useRef(null);
  const logoutTimer = useRef(null);
  const tickTimer   = useRef(null);

  function reset() {
    clearTimeout(warnTimer.current);
    clearTimeout(logoutTimer.current);
    clearInterval(tickTimer.current);
    setCountdown(null);

    warnTimer.current = setTimeout(() => {
      setCountdown(5 * 60);
      tickTimer.current = setInterval(() => {
        setCountdown(c => {
          if (c <= 1) { clearInterval(tickTimer.current); return 0; }
          return c - 1;
        });
      }, 1000);
    }, WARN_AFTER);

    logoutTimer.current = setTimeout(() => onSignOut(), LOGOUT_AFTER);
  }

  useEffect(() => {
    const events = ["mousedown", "keydown", "touchstart", "scroll", "pointermove"];
    const handler = () => {
      if (warnTimer.current) reset();
    };
    events.forEach(e => window.addEventListener(e, handler, { passive: true }));
    reset();
    return () => {
      events.forEach(e => window.removeEventListener(e, handler));
      clearTimeout(warnTimer.current);
      clearTimeout(logoutTimer.current);
      clearInterval(tickTimer.current);
    };
  }, []); // eslint-disable-line

  return { countdown };
}
